import { Dialog, DialogTitle, Link, Grid } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { SuccessButton, SuccessTextGrid } from "./registerStyles"
import { DialogProps } from "../../../interfaces/interfaces"
import { useTranslation } from 'react-i18next';
import { useRouteNavigator } from "../../../routes/useRouteNavigator";

export function Success(props: DialogProps) {
  const routeNavigator = useRouteNavigator();
  const { onClose, open } = props;

  const { t } = useTranslation('account');

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle sx={{ backgroundColor: "dialog.title.background", color: "dialog.title.color" }}>
        <Grid container direction="row">
          <Grid item xs={10}>{t('registrationSuccessful')}</Grid>
          <CheckIcon />
        </Grid>
      </DialogTitle>
      <SuccessTextGrid>
        • {t('confirmationEmailAndSmsSent')}
      </SuccessTextGrid>
      <SuccessTextGrid>
        • {t('refreshConfirmationTextPart1')} <Link onClick={() => routeNavigator.goToAccountSettings()}>{t('refreshConfirmationTextPart2Link')}</Link> {t('refreshConfirmationTextPart3')}
      </SuccessTextGrid>
      <SuccessButton variant="contained" onClick={() => routeNavigator.goToAccount()}>
        {t('successButtonAfterRegistration')}
      </SuccessButton>
    </Dialog>
  );
}